var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "760px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', {
          attrs: {
            "bottom": "",
            "color": "accent",
            "dark": "",
            "fab": "",
            "fixed": "",
            "right": ""
          },
          on: {
            "click": _vm.create
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.show ? _c('v-card', [_c('v-card-title', [!_vm.editItem._id ? _c('span', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("CP 신규등록")]) : _c('span', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("CP 수정")])]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.username,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "username", $$v);
      },
      expression: "editItem.username"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-password-field', {
    attrs: {
      "label": "비밀번호",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.password,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "password", $$v);
      },
      expression: "editItem.password"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.name,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "name", $$v);
      },
      expression: "editItem.name"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "phone", $$v);
      },
      expression: "editItem.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.email,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "email", $$v);
      },
      expression: "editItem.email"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs['daum-postcode'].open();
      }
    },
    model: {
      value: _vm.editItem.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "postcode", $$v);
      },
      expression: "editItem.postcode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기본주소",
      "placeholder": " ",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs['daum-postcode'].open();
      }
    },
    model: {
      value: _vm.editItem.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "address1", $$v);
      },
      expression: "editItem.address1"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상세주소",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "address2", $$v);
      },
      expression: "editItem.address2"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("발행 금액 제한")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.limitEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "limitEnabled", $$v);
      },
      expression: "editItem.riskManagement.limitEnabled"
    }
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발행 금액 제한(일간)",
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.editItem.riskManagement.limitEnabled,
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.dailyLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "dailyLimit", $$v);
      },
      expression: "editItem.riskManagement.dailyLimit"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발행 금액 제한(월간)",
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.editItem.riskManagement.limitEnabled,
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.monthlyLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "monthlyLimit", $$v);
      },
      expression: "editItem.riskManagement.monthlyLimit"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("사용 처리 허용")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.payable,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "payable", $$v);
      },
      expression: "editItem.payable"
    }
  })], 1)]), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("사용자 매치 허용")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.payerMatch,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "payerMatch", $$v);
      },
      expression: "editItem.payerMatch"
    }
  })], 1)]), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("API 발송 옵션")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.apiLimitEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "apiLimitEnabled", $$v);
      },
      expression: "editItem.riskManagement.apiLimitEnabled"
    }
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "API 요청 제한 개수",
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.editItem.riskManagement.apiLimitEnabled,
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.apiLimit,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "apiLimit", $$v);
      },
      expression: "editItem.riskManagement.apiLimit"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4"
  }, [_c('strong', [_vm._v("팝빌")])]), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "사업자번호(-제외)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.businessNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "businessNumber", $$v);
      },
      expression: "editItem.popbill.businessNumber"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "회사명",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "companyName", $$v);
      },
      expression: "editItem.popbill.companyName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "고객센터",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.customerCenter,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "customerCenter", $$v);
      },
      expression: "editItem.popbill.customerCenter"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "채널톡ID",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.plusFriendId,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "plusFriendId", $$v);
      },
      expression: "editItem.popbill.plusFriendId"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "팝빌ID",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.username,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "username", $$v);
      },
      expression: "editItem.popbill.username"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "템플릿코드",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.templateCode,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "templateCode", $$v);
      },
      expression: "editItem.popbill.templateCode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발신번호",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.popbill.tel,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.popbill, "tel", $$v);
      },
      expression: "editItem.popbill.tel"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "subtitle-1 pt-4"
  }, [_c('strong', [_vm._v("관리자 알람")])]), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(1차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.createComma(_vm.editItem.riskManagement.alarmPrices[0], 0);
      }
    },
    model: {
      value: _vm.editItem.riskManagement.alarmPrices[0],
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement.alarmPrices, 0, $$v);
      },
      expression: "editItem.riskManagement.alarmPrices[0]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(2차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.createComma(_vm.editItem.riskManagement.alarmPrices[1], 1);
      }
    },
    model: {
      value: _vm.editItem.riskManagement.alarmPrices[1],
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement.alarmPrices, 1, $$v);
      },
      expression: "editItem.riskManagement.alarmPrices[1]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(3차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.createComma(_vm.editItem.riskManagement.alarmPrices[2], 2);
      }
    },
    model: {
      value: _vm.editItem.riskManagement.alarmPrices[2],
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement.alarmPrices, 2, $$v);
      },
      expression: "editItem.riskManagement.alarmPrices[2]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(4차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.createComma(_vm.editItem.riskManagement.alarmPrices[3], 3);
      }
    },
    model: {
      value: _vm.editItem.riskManagement.alarmPrices[3],
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement.alarmPrices, 3, $$v);
      },
      expression: "editItem.riskManagement.alarmPrices[3]"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pr-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "담당자 이름",
      "placeholder": " ",
      "hide-details": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": ""
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "알람 연락처",
      "placeholder": " ",
      "hide-details": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return function () {
          _vm.editItem.riskManagement.alarmPhones.push(_vm.phone);

          _vm.phone = '';
        }($event);
      }
    },
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function click() {
        _vm.editItem.riskManagement.alarmPhones.push(_vm.phone), _vm.editItem.riskManagement.alarmNames[_vm.editItem.riskManagement.alarmPhones.length - 1] = _vm.name, _vm.phone = '', _vm.name = '';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "20"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1)], 1), _c('v-row', _vm._l(_vm.editItem.riskManagement.alarmPhones, function (alarmPhone, index) {
    return _c('v-col', {
      key: index,
      staticClass: "pr-1",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      attrs: {
        "close": "",
        "color": "secondary"
      },
      on: {
        "click:close": function clickClose($event) {
          _vm.editItem.riskManagement.alarmPhones.splice(index, 1), _vm.editItem.riskManagement.alarmNames.splice(index, 1);
        }
      }
    }, [_vm._v(_vm._s(_vm.editItem.riskManagement.alarmNames[index]) + " " + _vm._s(alarmPhone))])], 1);
  }), 1), _c('v-textarea', {
    staticClass: "mt-4",
    attrs: {
      "label": "알람 메시지",
      "placeholder": " ",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.riskManagement.alarmMessage,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem.riskManagement, "alarmMessage", $$v);
      },
      expression: "editItem.riskManagement.alarmMessage"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "input": function input(_ref2) {
        var postcode = _ref2.postcode,
            address = _ref2.address;
        _vm.editItem.postcode = postcode;
        _vm.editItem.address1 = address;
      }
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }